import { Auth0Provider } from "@auth0/auth0-react";
import * as Toast from "@radix-ui/react-toast";
import { Theme, ThemePanel } from "@radix-ui/themes";
import "@radix-ui/themes/styles.css";
import { ToastListener } from "components/common/toast-listener";
import env from "config";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/_index.scss";

const ENABLE_PANEL = false;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={env.auth0.domain}
      clientId={env.auth0.clientId}
      useRefreshTokens={true}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: env.auth0.audience,
        scope: "openid profile email offline_access read:current_user",
      }}
    >
      <BrowserRouter>
        <Theme accentColor="indigo" grayColor="slate">
          {!env.production && ENABLE_PANEL && <ThemePanel />}
          <Toast.Provider swipeDirection="left" duration={5_000}>
            <ToastListener position="top-right" />
            <App />
          </Toast.Provider>
        </Theme>
      </BrowserRouter>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (!env.production) {
  reportWebVitals(console.info);
}
